const root = "roles";
const rolesEndpoints = {
    all: () => root,
};
export { rolesEndpoints };
